import React from 'react'
import {connect} from 'react-redux'
import {Chart} from 'react-google-charts';
import {formatarReal} from '../../util/numberUtil';


export class GraficoVendasPorDiaMesAno extends React.Component {


    formatarPeriodo(periodo) {
        if (periodo.length > 4) {
            let split = periodo.split('-');
            return `${split[1]}/${split[0]}`
        }
        return periodo;
    }

    recuperarTipo(periodo) {
        if (periodo.length === 5) {
            return 'Dia'
        }
        if (periodo.length === 4) {
            return 'Ano'
        }
        return 'Mês'
    }

    tooltip(item, seCancelamento) {
        if (seCancelamento) {
            return '<div class="google-visualization-tooltip-item"><strong style="font-size: 16px";">' + this.formatarPeriodo(item.periodo) + '</strong><br/>' +
                '<span style="font-size: 16px"> (T.Cancelado=):  <strong>' + formatarReal(item.valorTotalCancelamentos.toString()) + '</strong></span><br/>' +
                '<span style="font-size: 16px"> (Q.Canceladas=):  <strong>' + item.quantidadeCancelamentos + '</strong></span><br/>' +
                '<span style="font-size: 16px"> (I.liquid=):  <strong>' + formatarReal(item.valorTotalImposto.toString()) + '</strong></span><br/>' +
                '<span style="font-size: 16px"> (L. Comissão=):  <strong>' + formatarReal(item.valorTotalComissaoCancelamentos.toString()) + '</strong></span></div>'

        }
        return '<div class="google-visualization-tooltip-item"><strong style="font-size: 16px";">' + this.formatarPeriodo(item.periodo) + '</strong><br/>' +
            '<span style="font-size: 16px"> (T.Aprovado=):  <strong>' + formatarReal(item.valorTotalVendas.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (Q.Aprovado=):  <strong>' + item.quantidadeVendas + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (I.liquid=):  <strong>' + formatarReal(item.valorTotalImpostoCancelamentos.toString()) + '</strong></span><br/>'+
            '<span style="font-size: 16px"> (L. Comissão=):  <strong>' + formatarReal(item.valorTotalComissao.toString()) + '</strong></span></div>'

    }

    executarDownload(arquivo, tipo) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], {type: 'text/csv;'}));
        if(tipo === 'Dia') {
            a.download = 'VexBi - Faturamento por Dia.csv';
        } else {
            a.download = 'VexBi - Faturamento por Mês.csv';
        }

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    exportarGraficoPorPeriodo(tipo) {
        let arquivo = 'Data;T. Aprovado;Q. Aprovado; Imposto Líquido; L. Comissão;T. Cancelado;Q. Cancelada;Imposto Líquido Cancelado;L. Comissão Cancelada\n';

        let retorno = [...this.props.vexadoBI.totalAgrupadoPorSituacao].reverse();

        arquivo = `${arquivo}${retorno.map(it => {
            const periodo = this.formatarPeriodo(it.periodo);
            const valorTotalVendas = it.valorTotalVendas.toString().replace('.', ',')
            const valorTotalImposto = it.valorTotalImpostoCancelamentos.toString().replace('.', ',')
            const valorTotalComissao = it.valorTotalComissao.toString().replace('.', ',')
            const valorTotalCancelamentos = it.valorTotalCancelamentos.toString().replace('.', ',')
            const valorTotalImpostoCancelamentos = it.valorTotalImposto.toString().replace('.', ',')
            const valorTotalComissaoCancelamentos = it.valorTotalComissaoCancelamentos.toString().replace('.', ',')

            let valor = `${periodo};"${valorTotalVendas}";"${it.quantidadeVendas}";"${valorTotalImposto}";"${valorTotalComissao}";"${valorTotalCancelamentos}";"${it.quantidadeCancelamentos}";"${valorTotalImpostoCancelamentos}";"${valorTotalComissaoCancelamentos}"`
            return valor;
        }).join('\n')}\n`;

        this.executarDownload(arquivo, tipo)
    }

    render() {
        const retorno = [];
        retorno.push(['Dia', 'Vendas', {
            role: 'tooltip',
            type: 'string',
            p: {html: true}
        }, 'Cancelamento', {
            role: 'tooltip',
            type: 'string',
            p: {html: true}
        }]);

        this.props.vexadoBI.totalAgrupadoPorSituacao.forEach((it) => retorno.push([this.formatarPeriodo(it.periodo), it.valorTotalVendas, this.tooltip(it), it.valorTotalCancelamentos, this.tooltip(it, true)]));
        const tipo = this.props.vexadoBI.totalAgrupadoPorSituacao[0] ? this.recuperarTipo(this.props.vexadoBI.totalAgrupadoPorSituacao[0].periodo) : '';
        return <React.Fragment>
            <Chart
                chartType="ComboChart"
                width="100%"
                height={this.props.full ? '800px' : '400px'}
                data={retorno}
                options={{
                    title: `Vendas por ${tipo}`,
                    vAxis: {title: 'Valor'},
                    hAxis: {title: tipo},
                    seriesType: 'bars',
                    tooltip: {isHtml: true}
                }}
            />
            {this.props.full ? null : <button className="input-group-text bg-white btn-campo-busca float-right"
                                            onClick={() => this.props.expandir('diaMes')}>
                Expandir
            </button>}
            {this.props.full ? null : <button className="input-group-text btn-laranja btn-campo-busca float-right exportar"
                                            onClick={() => this.exportarGraficoPorPeriodo(tipo)}>Exportar Lista</button>}    
        </React.Fragment>
    }
}

export function mapStateToProps(state) {
    return {
        vexadoBI: state.vexadoBI
    }
}

export default connect(mapStateToProps, {})(GraficoVendasPorDiaMesAno)
